import * as React from 'react'
import * as UI from '@brewlogix/blx-ui'
import { LocationProductRelationship } from 'src/types/schema/graphql'
import deCamel from 'src/util/helpers/deCamel'

enum AvailabilityIcon {
    canned = 'Seltzer',
    onTap = 'Beer',
    growler = 'Keg',
}

const AvailabilityPills: React.FC<{ availability: LocationProductRelationship }> = ({
    availability,
}) => {
    const formatTitle = (format: string): string =>
        `'Available ${format === 'onTap' ? 'on tap' : 'in ' + format} at this location'`
    return (
        <>
            {Object.keys(AvailabilityIcon)
                .filter((item) => availability[item])
                .map((format) => {
                    return (
                        <UI.Pill
                            key='format'
                            title={formatTitle(format)}
                            customClasses='whitespace-nowrap capitalize'
                            icon={AvailabilityIcon[format]}
                            iconAlignment='left'
                            label={deCamel(format)}
                            theme={format === 'onTap' ? 'warning' : 'default'}
                        />
                    )
                })}
        </>
    )
}

export default AvailabilityPills
